import React, {useState} from 'react';
import {useFormik} from 'formik';
import {Form, Col, Button, Alert} from 'react-bootstrap';
import * as yup from 'yup';
import '../../styles/css/UserList.css';
import micro_reporter_api from '../../apis/micro-reporter-api';
import Utils from "../../libraries/utils";

const ChangePasswordForm = () => {

    const [showIncorrectErrorMessage, setShowIncorrectErrorMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [showNotMatchMessage, setShowNotMatchMessage] = useState(false);
    let currentPasswordErrorMessage = "Current password is incorrect!"
    let errorMessage = "An unexpected error was encountered!";
    let notMatchMessage = "New password and confirm password does not match!";

    const formik = useFormik({
        initialValues: {
            username: JSON.parse(localStorage.getItem('user')).username,
            currentPassword: "",
            newPassword: "",
            confirmPassword: ""
        },
        validationSchema: yup.object({
            currentPassword: yup.string().required('Current password can not be blank.'),
            newPassword: yup
                .string().required('New Password can not be blank.')
                .min(8, "Password must contains min 8 Characters, One Uppercase, One Lowercase, One Number and One Special Character.")
                .matches(/([A-Z])/, "Password must contains One Uppercase.")
                .matches(/([a-z])/, "Password must contains One Lowercase.")
                .matches(/([0-9])/, "Password must contains One Number.")
                .matches(/([ !"#$%&'()*+,-./:;<=>?@\\^_`{|}~])/, "Password must contains One Special Character.")
            ,
            confirmPassword: yup.string().required('Confirm Password can not be blank.'),
        }),
        onSubmit: values => {
            if(values.newPassword !== values.confirmPassword){
                showNotMatchError();
            }else{
                changePassword(values);
            }
          },
    });

    const changePassword = (values) => {
        (async () => {
            try{
                Utils.loadingScreen("show");
                let user = JSON.parse(localStorage.getItem("user"));
                let headers = {"userId": user.id, "username":user.username, "relatedName": encodeURIComponent(user.username), "relatedId": user.id};
                const config = {headers};
                await micro_reporter_api.post('/micro-reporter/user/set-password', values, config).then(
                    () => {
                        window.location.reload();
                        Utils.loadingScreen("hide");
                    }
                );
            }catch (err){
                Utils.loadingScreen("hide");
                try{
                    showMessages(err.response);
                }catch{
                    showError();
                }
            }
        })();
    };

    const showMessages = (response) => {
        switch(response.status) {
            case 400:
                showLoginError();
              break;
            case 404:
                showError();
              break;
            default:
                showError();
          } 
    };

    const showLoginError = () => {
        setShowIncorrectErrorMessage(true);
        setShowErrorMessage(false);
        setShowNotMatchMessage(false);
    }

    const showNotMatchError = () => {
        setShowNotMatchMessage(true);
        setShowIncorrectErrorMessage(false);
        setShowErrorMessage(false);
    }

    const showError = () => {
        setShowErrorMessage(true);
        setShowIncorrectErrorMessage(false);
        setShowNotMatchMessage(false);
    }

    return(
        <div className="container">
            <div>
                <div id="user-list-center-div">
                <Form noValidate onSubmit={formik.handleSubmit} id="user-list">
                    {showErrorMessage ?
                        (
                            <Alert variant="danger">
                                {errorMessage}
                            </Alert>
                        ) : null
                    }
                    <Form.Row>
                        <Form.Group as={Col} md="12" controlId="validationFormik06">
                            <Form.Label>Username</Form.Label>
                            <Form.Control
                            disabled
                            type="text"
                            name="username"
                            onChange={formik.handleChange}
                            value={formik.values.username}
                            onBlur={formik.handleBlur}
                            />
                            {formik.touched.username && formik.errors.username ? (
                                <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.username}</div>
                            ) : null}
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                    <Form.Group as={Col} md="12" controlId="validationFormik07">
                            <Form.Label>Current Password</Form.Label>
                            <Form.Control
                            type="password"
                            name="currentPassword"
                            onChange={formik.handleChange}
                            value={formik.values.currentPassword}
                            onBlur={formik.handleBlur}
                            />
                            {formik.touched.currentPassword && formik.errors.currentPassword ? (
                                <div style={{fontFamily:"Lexend Deca", fontSize:"11px", color: "#ff0000"}}>{formik.errors.currentPassword}</div>
                            ) : null}
                            {showIncorrectErrorMessage ?
                                (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000", marginBottom:"5px"}}>{currentPasswordErrorMessage}</div>
                                ) : null
                            }
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="12" controlId="validationFormik08">
                            <Form.Label>New Password</Form.Label>
                            <Form.Control
                            type="password"
                            name="newPassword"
                            onChange={formik.handleChange}
                            value={formik.values.newPassword}
                            onBlur={formik.handleBlur}
                            />
                            {formik.touched.newPassword && formik.errors.newPassword ? (
                                <div style={{fontFamily:"Lexend Deca", fontSize:"11px", color: "#ff0000"}}>{formik.errors.newPassword}</div>
                            ) : null}
                            {showNotMatchMessage ?
                                (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000", marginBottom:"5px"}}>{notMatchMessage}</div>
                                ) : null
                            }
                            </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="12" controlId="validationFormik09">
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control
                                type="password"
                                name="confirmPassword"
                                onChange={formik.handleChange}
                                value={formik.values.confirmPassword}
                                onBlur={formik.handleBlur}
                                />
                                {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"11px", color: "#ff0000"}}>{formik.errors.confirmPassword}</div>
                                ) : null}
                            </Form.Group>
                    </Form.Row>
                    <Button type="submit" block>
                        Save
                    </Button>
                </Form>
                </div>
            </div>
        </div>
    );
};

export default ChangePasswordForm;
